import React, { useEffect } from "react";
import { Auth, GetEntityDetails, GetRoles, baseUrl } from "./../utils/auth";
import Cookie from "universal-cookie";
import axios from "axios";
import jwt from "jwt-decode";

export const TenantID = GetEntityDetails();

const roles = GetRoles();

export const isSuperAdminAccess = roles?.includes('Super Sys Admin') || roles?.includes('Distributor Admin') ? true : false;
let cookie = new Cookie();

const getHeaders = () => {
    let tenantId = cookie.get("entityId");
    let accessToken = cookie.get('user');
    let authorization = cookie.get("authorization");
    return {
        "Content-Type": "application/json",
        "X-tenantID": tenantId,
        "X-Authorization": `Bearer ${accessToken}`,
        "Authorization": `Bearer ${authorization}`,
    };
}

const getMultipartHeaders = () => {
    const headers = getHeaders();
    delete headers['Content-Type'];
    return headers;
};

const resolveRequestHeaders = (data) => {
    if (typeof FormData !== 'undefined' && data instanceof FormData) {
        return getMultipartHeaders();
    }
    return getHeaders();
};

export const GET = (url, options = {}) => {
    return axios(`${baseUrl()}/${url}`, {
        method: "GET",
        headers: getHeaders(),
        ...options,
    });
};

export const PUT = (url, data) => {
    return axios(`${baseUrl()}/${url}`, {
        method: "PUT",
        headers: resolveRequestHeaders(data),
        data,
    });
};

export const POST = (url, data, options = {}) => {
    const { headers: optionHeaders, ...restOptions } = options;
    return axios(`${baseUrl()}/${url}`, {
        method: "POST",
        data,
        ...restOptions,
        headers: {
            ...resolveRequestHeaders(data),
            ...(optionHeaders || {}),
        },
    });
};

export const DELETE = (url, data) => {
    return axios(`${baseUrl()}/${url}`, {
        method: "DELETE",
        headers: getHeaders(),
        data,
    });
};

export const PATCH = (url, data) => {
    return axios(`${baseUrl()}/${url}`, {
        method: "PATCH",
        headers: resolveRequestHeaders(data),
        data,
    });
};
